import React from 'react';
import { BsBriefcase } from 'react-icons/bs';
import { HiAcademicCap } from 'react-icons/hi2';

const TimelineEntry = ({ item, side }) => (
  <div
    className="relative pl-6"
    data-aos={side === 'left' ? 'fade-right' : 'fade-left'}
  >
    {/* Timeline dot */}
    <div className={`absolute left-0 top-3 w-3 h-3 rounded-full ring-2 dark:ring-[#0d1224] ring-slate-50
      ${side === 'left'
        ? 'bg-gradient-to-r from-blue-500 to-indigo-600'
        : 'bg-gradient-to-r from-violet-500 to-purple-600'
      }`}
    />
    {/* Card */}
    <div className={`p-5 rounded-2xl dark:border border dark:border-slate-700/50 border-slate-200
      dark:bg-[#0e0c29] bg-white transition-all duration-300
      ${side === 'left'
        ? 'dark:hover:border-blue-500/30 hover:border-blue-400/30 dark:hover:shadow-blue-500/10 hover:shadow-blue-100/50'
        : 'dark:hover:border-violet-500/30 hover:border-violet-400/30 dark:hover:shadow-violet-500/10 hover:shadow-violet-100/50'
      } hover:shadow-md hover:-translate-y-0.5 transition-transform`}
    >
      <span className={`text-xs font-medium ${side === 'left' ? 'text-blue-400' : 'text-violet-400'}`}>
        {item.duration}
      </span>
      <h4 className="text-sm md:text-base font-semibold dark:text-white text-slate-900 mt-1">
        {item.title}
      </h4>
      <p className="text-sm dark:text-slate-400 text-slate-600 mt-1">
        {item.company || item.institution}
      </p>
      {item.grade && (
        <p className="text-xs dark:text-slate-500 text-slate-400 mt-2 italic">
          {item.grade}
        </p>
      )}
    </div>
  </div>
);

const ProfessionalJourney = ({ experiences, educations }) => {
  return (
    <section id="professional-journey" className="w-full" data-aos="fade-up">

      {/* Section Header */}
      <div className="text-center mb-12">
        <p className="section-eyebrow">My path</p>
        <h2 className="section-heading">Professional Journey 💼</h2>
        <div className="section-divider" />
      </div>

      {/* Two-column layout */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16">

        {/* Work Experience */}
        <div>
          <div className="flex items-center gap-3 mb-6">
            <div className="p-2 rounded-lg bg-blue-500/10 text-blue-400">
              <BsBriefcase size={18} />
            </div>
            <h3 className="text-lg font-bold dark:text-white text-slate-900">Work Experience</h3>
          </div>

          <div className="relative border-l-2 border-blue-500/20 flex flex-col gap-6 ml-1.5">
            {experiences.map(exp => (
              <TimelineEntry key={exp.id} item={exp} side="left" />
            ))}
          </div>
        </div>

        {/* Horizontal divider on mobile */}
        <div className="lg:hidden h-px bg-gradient-to-r from-transparent via-purple-500/30 to-transparent" />

        {/* Education */}
        <div>
          <div className="flex items-center gap-3 mb-6">
            <div className="p-2 rounded-lg bg-violet-500/10 text-violet-400">
              <HiAcademicCap size={18} />
            </div>
            <h3 className="text-lg font-bold dark:text-white text-slate-900">Education</h3>
          </div>

          <div className="relative border-l-2 border-violet-500/20 flex flex-col gap-6 ml-1.5">
            {educations.map(edu => (
              <TimelineEntry key={edu.id} item={edu} side="right" />
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default ProfessionalJourney;
